enum ChartGroupActionType {
  CHART_TYPE = 'chart_type',
  BUTTONS = 'buttons',
  CLICKABLE = 'clickable',
  SELECTABLE = 'selectable',
  LIST = 'list',
  TIMEZONE = 'timezone',
  // TODO when adding more options, we will add more group action (dropdown, multiselect, datepicker, string, number, etc.)
}

export default ChartGroupActionType;
